import React, { useEffect, useState } from 'react';
import { Nav, Navbar, Container, NavDropdown } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import UserIcon from '../components/auth/UserIcon'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getDesignatedDepartments } from '../utils/api';
import { getUser } from '../utils/api';

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faLayerGroup, faPuzzlePiece, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFileDownload, faLayerGroup, faPuzzlePiece, faGlobe)

const NavBar = ({setChosenDepartment, chosenDepartment}) => {
    const history = useHistory();
    const loaction = useLocation();
    const animatedComponents = makeAnimated();
    const [designatedDepartments, setDesignatedDepartments] = useState([]);
    const [page, setPage] = useState("Files")
    const [zoom, setZoom] = useState(null)
    const [user, setUser] = useState(null)

    useEffect(() => {
      history.push("/files")
      getDesignatedDepartments(setDesignatedDepartments)
    },[])

    useEffect(() => {
      designatedDepartments.length !== 0 && setChosenDepartment(designatedDepartments[0].value)  
    }, [designatedDepartments])

    useEffect(() => {
      getUser(setUser)
    },[])
  
    useEffect(() => {
      setZoom(user?.zoom_value)
    }, [user])
  
    useEffect (() => {
      if(zoom !== undefined && zoom !==null) {
          let zoomString = zoom.toString() + "%";    
          document.documentElement.style.setProperty('--zoom-level',zoomString)
      }     
    }, [zoom])

    const handleClick = (route) => {
      setPage(route.charAt(0).toUpperCase() + route.slice(1))
      route === "website" ? window.open("https://www.mach-intranet.com") : history.push("/" + route)

    }
    return (
        <Navbar variant="dark" className="top-navbar" >  

        <Container fluid style={{paddingLeft: "1%"}}>      

  
            <div className="department-select">
                <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    value={{label:chosenDepartment}}
                    options={designatedDepartments}
                    onChange={(e) => {setChosenDepartment(e.value)}}
                
                />
            </div>

            <NavDropdown title={page} id="collasible-nav-dropdown" className="navbar-dropdown">

              <NavDropdown.Item className="dropdown-item" onClick={() => handleClick("files")}>
                <FontAwesomeIcon icon={faFileDownload} size='1x' className='all-font-icons' style={{marginRight: "8px", marginLeft: "2px"}} />
                Files
              </NavDropdown.Item>

              <NavDropdown.Item className="dropdown-item" onClick={() => handleClick("templates")}>
                <FontAwesomeIcon icon={faLayerGroup} size='1x' className='all-font-icons' style={{marginRight: "6px"}}/>
                Templates
              </NavDropdown.Item>

              <NavDropdown.Item className="dropdown-item" onClick={() => handleClick("sections")}>
                <FontAwesomeIcon icon={faPuzzlePiece} size='1x' className='all-font-icons' style={{marginRight: "5px", marginLeft: "1px"}}/>                
                 Sections
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item className="dropdown-item" onClick={() => handleClick("website")}>
                <FontAwesomeIcon icon={faGlobe} size='1x' className='all-font-icons' style={{marginRight: "7px", marginLeft: "1px"}}/>
                Website
              </NavDropdown.Item>     

            </NavDropdown>

            <div style={{float: 'right'}}>
            <UserIcon user={user} zoom={zoom} setZoom={setZoom}/>
            </div>
            </Container>

      </Navbar>
    )
}

export default NavBar